import React, {useContext, useState, useEffect} from 'react';
import { useNavigate, useParams, Link } from "react-router-dom";
import { errorMessage } from '../errorHandler';
import { InputContext } from '../contexts/InputContext';
import authServices from '../services/authServices';

const MenuUsuario = () => {
  let { uuid } = useParams();
  const navigate = useNavigate();

  const [authInformation, setAuthInformation, checkSignIn] = useContext(InputContext)

  const [datosUsuario, setDatosUsuario] = useState({password: null, menuUsuario: true});
  const [saving, setSaving] = useState(false);
  const [renderHTML, setRenderHTML] = useState(false);

  useEffect(() => {

    if(uuid){
      setRenderHTML(true)
      signIn(uuid)
    } else {
      setRenderHTML(false)
    }
  }, [uuid]);

  const signIn = async (uuid) => {
    try {
      setSaving(true)
      const response = await authServices.signIn({uuid: uuid, ...datosUsuario});
      const data = response.data

      setAuthInformation({
        token: data.token,
        nombre: data.nombre,
        user_id: data.user_id,
        rol: data.rol,
        marca: data.marca,
        condiciones_aceptadas: data.condiciones_aceptadas,
        autenticado: true,
      })
      localStorage.setItem('token', data.token);

      setSaving(false)

    } catch (error) {
      setSaving(false)
      setAuthInformation({token: undefined, nombre: undefined, user_id: undefined, rol: undefined, autenticado: false})
      localStorage.removeItem('token');

      errorMessage(error)
    }
  };


  const salir = () => {
    navigate(`/acceso`);
  };


  return (
    <div className="container p-0 bg-main-usuario d-flex flex-column align-items-center">
      <div className='m-auto'>
        <h3 className='mb-3'>Menú principal</h3>
      {
        renderHTML && authInformation.autenticado ? (
          <>
            {saving ? (
                <>
                <div className="position-absolute top-0 start-0 w-100 h-100">
                  <h3 className='mt-3 text-center'>Aguarde</h3>
                </div>

                </>
              ) : (
                <>
                  <Link className="btn btn-success d-block mb-3" to={`/pedir-cancion`}>Pedir Canción</Link>
                  <Link className="btn btn-success d-block mb-3" to={`/compartir-foto`}>Tomar Foto</Link>
                </>
              )}
          </>
        ) : (
          <>
          Sin acceso
          </>
        )
      }
      </div>
    </div>
  );
};

export default MenuUsuario;